import React from "react";
import { Modal, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const NetworkDisconnected = ({ isOpen }) => {
  const navigate = useNavigate();

  const handleExit = () => {
    navigate("/admin/pending");
  };

  return (
    <Modal show={isOpen} backdrop="static" keyboard={false} size="md" scrollable>
      <Modal.Header className="border-0 pb-0">
        <Modal.Title className="w-100 text-center">
          <div className="d-flex flex-column align-items-center gap-2">
            <div 
              className="d-flex align-items-center justify-content-center rounded-circle" 
              style={{
                width: "60px",
                height: "60px",
                backgroundColor: "#ff4444",
                animation: "pulse 2s infinite"
              }}
            >
              <i className="fa fa-wifi" style={{ fontSize: "28px", color: "white" }}></i>
            </div>
            <h5 className="mb-0 fw-bold modal-heading">No Internet Connection</h5>
          </div>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="text-center px-4 py-3">
        <p className="mb-2" style={{ fontSize: "15px", lineHeight: "1.6", color: "#555" }}>
          The test will resume automatically once the network connection is restored, or you may exit now and access it later when your connection is stable.
        </p>
      </Modal.Body>

      <Modal.Footer className="border-0 justify-content-center pb-4">
        <Button 
          variant="danger" 
          onClick={handleExit}
          className="px-4 py-2"
          style={{
            minWidth: "120px",
            fontWeight: "500"
          }}
        >
          <i className="fa fa-sign-out me-2"></i>
          Exit Test
        </Button>
      </Modal.Footer>
      
      <style>{`
        @keyframes pulse {
          0%, 100% {
            transform: scale(1);
            opacity: 1;
          }
          50% {
            transform: scale(1.05);
            opacity: 0.8;
          }
        }
        
        @media (max-width: 576px) {
          .modal.show .modal-dialog {
            margin: 20px auto 0 auto !important;
            transform: none !important;
          }
          .modal-body p {
            font-size: 14px !important;
          }
          .modal-footer button {
            width: 100%;
          }
          .modal-heading{
            font-size: 18px !important;
          }  
        }
      `}</style>
    </Modal>
  );
};

export default NetworkDisconnected;
